import React from 'react'
import styled from 'styled-components/macro'
import { faLink } from '@fortawesome/pro-light-svg-icons'
import { ButtonLink } from '../../components'

const links = [
  {
    title: 'Checklista inför besiktning',
    href: 'https://opus.se/nyheter/nyheter/2020-07-27-checklista-infor-besiktning',
  },

  {
    title: 'Coronasäker besiktning',
    href: 'https://opus.se/nyheter/nyheter/2020-03-11-aktuell-information-med-anledning-av-corona-viruset?qs=corona',
  },

  {
    title: 'Klimatkompensera för din körning',
    href: 'https://opus.se/miljoansvar/100-klimatkompenserat/klimatkompensera-din-korning',
  },
]

const LinkList = styled.ul`
  padding: 0;
`
const ListItem = styled.li`
  list-style-type: none;
  margin-bottom: 2rem;
`

export function StartPageLinks() {
  return (
    <LinkList>
      {links.map(({ title, href }, idx) => (
        <ListItem key={idx}>
          <ButtonLink alignLeft className="fullWidth" icon={faLink} target="_blank" to={{ pathname: href }}>
            {title}
          </ButtonLink>
        </ListItem>
      ))}
    </LinkList>
  )
}
